import isServerSide from '@helpers/misc/isServerSide'
import useWidth from '@hooks/useWidth'

export default function useLayout(website) {
  const width = useWidth()
  const isMobile = width < 768
  if (website && website.menuLayout === 'categories') return 'categories'

  if (isMobile) return 'mobile'
  if (!website) return 'v2'
  if (!website.menuLayout) return 'v2'
  return website.menuLayout
}
